export default {"src":"/_next/static/media/SimplePoop.52e30563.svg","height":19,"width":20,"blurWidth":0,"blurHeight":0};